export default __webpack_public_path__ + "static/media/SCARAArmImg.8ebfe10a.png";